import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Flex,
  Loader,
  Radio,
  RadioGroupField,
  TextField,
  Text,
  PasswordField,
  Grid,
  useTheme,
  View,
  CheckboxField,
  TextAreaField,
  Fieldset,
  SelectField,
  ScrollView,
  Alert,
  Autocomplete,
  Rating,
  Icon,
  DropZone,
  VisuallyHidden,
  Link,
  HighlightMatch,
  Card,
  Badge,
  Image,
} from "@aws-amplify/ui-react";
import "./Clienti.css";
import { formConfig, formReferentiConfig } from "./config";
import { MdCancel, MdDelete, MdDeleteOutline, MdDeleteSweep, MdDynamicForm, MdMap, MdRemove, MdRemoveCircle, MdRemoveDone, MdStar, MdWhatsapp } from "react-icons/md";
import { getClientiValues, getFileUrl, getReferenteAPI, getReferentiListAPI, uploadFileAPI } from "../../data/api";
import { getUrl } from "aws-amplify/storage";
import Webcam from "react-webcam";
const { v4: uuidv4 } = require('uuid');

const ClienteForm = (props) => {

  // handle upload file
  const [isUploading, setIsUploading] = useState({});
  const [showWebcam, setShowWebcam] = useState({});
  const [isErrorUpload, setIsErrorUpload] = useState({});
  const uploadFile = async (field, file: File, index?, outerField?) => {
    setIsUploading({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: true})
    setIsErrorUpload({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: false})
    try{  
      const reader = new FileReader();
      reader.onload = async (event) => {
        try{
          const fileBody = {
            file_name: `${uuidv4()}${file.name.slice(file.name.lastIndexOf('.'))}`,
            file_content: (event.target.result as string).split(',')[1],
            category: field.documentCategory,
            document_type: field.documentType
          }
          const uploadResponse = await uploadFileAPI(fileBody);
          props.onChange({target: {name: field.name, value: uploadResponse.file_path}});
          await fetchImageUrl(field, uploadResponse.file_path);
          setIsUploading({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: false})
          setIsErrorUpload({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: false})
        } catch (e) {
          console.log('Upload of file failed ', e);
          setIsUploading({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: false})
          setIsErrorUpload({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: true})
        }
      }
      reader.readAsDataURL(file);
    } catch (e) {
      console.log('Upload of file failed ', e);
      setIsUploading({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: false})
      setIsErrorUpload({...isUploading, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: true})
    }
  };

    // retrieve signed urls for saved images
    const [imagesUrl, setImagesUrl] = useState({});
    const fetchImageUrls = async () => {
      const newImagesUrl = {};
      const fetchFieldImageUrl = async (field, value, index?, outerField?) => {
        if (field.type === "UploadField" && field.dataType === 'image' && value) {
          const signedUrl = await getFileUrl(value);
          newImagesUrl[(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name] = signedUrl;
        } else if (field.type === "MultiField" && value?.length > 0) {
          for (let i = 0; i < value.length; i++) {
            for (const subField of field.fields) {
              await fetchFieldImageUrl(subField, value[i][subField.name], i, field.name);
            }
          }
        }
      };
      for (const section of formConfig.sections) {
        for (const field of section.fields) {
          const value = props.value[field.name];
          await fetchFieldImageUrl(field, value);
        }
      }
      setImagesUrl(newImagesUrl);
    };
    useEffect(() => {
      fetchImageUrls();
    }, []);

    // add a picture just uploaded
    const fetchImageUrl = async (field, value) => {
      const newImagesUrl = {};
      const signedUrl = await getFileUrl(value);
      newImagesUrl[field.name] = signedUrl;
      console.log(imagesUrl, newImagesUrl)
      setImagesUrl({...imagesUrl, ...newImagesUrl})
    };

  // download all possible values for form
  const [optionsList, setOptionsList] = useState(() => {
    const storage = localStorage.getItem('clientiValues');
    return storage ? JSON.parse(storage) : {};
  });
  const getOptions = async () => {
    try{
      const responseValues = await getClientiValues();
      setOptionsList(responseValues);
      localStorage.setItem('clientiValues', JSON.stringify(responseValues))
    } catch (e) {
      console.log("Error retrieving options list " + e)
    }
  }
  useEffect(() => {
    getOptions()
  }, [])

  const validateData = (value, type) => {
    if(value == null || value == ''){
      return true;
    }
    switch(type){
      case "phone":
        return value == '+39' ? true : /^(\+[0-9]{1,3})?[0-9]{8,}$/.test(value);
      case "CF":
        return true; ///^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i.test(value)
      case "email":
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(value)
      case "CAP":
        return /^\d{5}$/.test(value)
    }
    return true;
  };

  const [hover, setHover] = useState(null);
  const webcamRef = useRef(null);
  const renderField = (field, nestedField, index?, outerField?, innerField?) => {
    const propsValue = nestedField == true ? (props.value[outerField]?.[index]) : props.value;
    const value = nestedField == true ? (props.value[outerField]?.[index]?.[innerField]) : props.value[field.name];
    const savedValue = nestedField == true ? (props.savedValue[outerField]?.[index]?.[innerField]) : props.savedValue[field.name];
    if(field.hidden) return <React.Fragment key={field.name}></React.Fragment>;
    switch (field.type) {
      case "MultiField":
        return <React.Fragment key={field.name}>
          {props.value[field.name]?.map((f, index) => {
            return <React.Fragment key={f+index}>
              <Card variation="elevated"  
                backgroundColor="var(--amplify-colors-background-secondary)"
                borderRadius="6px"  marginBottom="20px" columnSpan={[1,1,1,4]}>
                <Grid 
                  templateColumns={{ base: '1fr', large: '1fr 1fr 1fr 1fr' }}
                  gap="10px">
                  {!field.hideButtons && <View columnSpan={[1,1,1,4]} textAlign="right">
                    <Icon 
                      as={MdCancel} 
                      color="red" 
                      marginLeft="5px" 
                      marginBottom="2px" 
                      style={{cursor: "pointer"}}  
                      onClick={() => {
                        props.onChange({ target: { name: field.name, value: props.value[field.name].filter(v => v !== f) } });
                      }}
                    />
                  </View>}
               {field?.fields?.map(o => 
                 renderField({
                   ...o, 
                   name: (field.name+'.'+index+'.'+o.name)
                 }, true, index, field.name, o.name))
               }
             </Grid>
           </Card>
         </React.Fragment>
          })}
          {!field.hideButtons && <View columnSpan={[1,1,1,4]}><Button className={"add-"+field.name} onClick={() => {
            props.onChange({ target: { name: field.name, value: [...(props.value[field.name] ?? []), {}] } });
          }}>Aggiungi {field.label.toLowerCase()}</Button></View>}
        </React.Fragment>
      case "TextField":
        return (
          <View columnSpan={field.columnSpan} key={field.name} className={field.name.replaceAll('.', '-')}>
            <TextField
              value={value}
              onChange={(e) => {
                field.onChange && field.onChange(e.target.value, props, optionsList); 
                (field.dataType == 'phone' && value === '+39') ? 
                  props.onChange({target: { name: field.name, value: null}}) : 
                  props.onChange(e);
              }}
              onBlur={props.onBlur}
              name={field.name}
              defaultValue={field.dataType == 'phone' ? '+39' : null}
              disabled={(field.isDisabled && field.isDisabled(props.value)) || field.disabled?.find(f => f.values.includes(propsValue?.[f.id])) !== undefined}
              label={<Text><b>{field.label}{field.isRequiredScheda&&<Text as="span" fontSize="0.8rem" color="red">{' *'}</Text>}</b>{value !== savedValue && <i> (modificato)</i>}</Text>}
              type={field.dataType}
              isRequired={field.isRequired}
              hasError={!validateData(value, field.validation)}
              errorMessage={!validateData(value, field.validation) ? "Formato non valido" : ""}
            />
            {field.dataType === 'phone' && value !== null && value !== '' && <Icon 
              as={MdWhatsapp} 
              marginLeft={"5px"}
              marginBottom={"4px"}
              onClick={() => window.open('https://wa.me/'+value, '_blank')} 
              style={{"cursor":"pointer"}}>
            </Icon>}
            {field.dataType === 'address' && value !== null && value !== '' && <Icon 
              as={MdMap} 
              marginLeft={"5px"}
              marginBottom={"4px"}
              onClick={() => window.open(`${"https://www.google.com/maps/search/?api=1&query="}${encodeURIComponent(
                field.getAddressString(props.value) ?? value
              )}`, '_blank')} 
              style={{"cursor":"pointer"}}>
            </Icon>}
          </View>
        );
        case "BadgeField":
          return (
            <View columnSpan={field.columnSpan} key={field.name} className={field.name.replaceAll('.', '-')}>
              <View marginBottom="10px"><b>{field.label}{field.isRequiredScheda&&<Text as="span" fontSize="0.8rem" color="red">{' *'}</Text>}</b>{JSON.stringify(value) !== JSON.stringify(savedValue) && <i> (modificato)</i>}</View>
              {value?.length > 0 && 
                <View marginBottom="10px">
                  {
                    value?.map(o => 
                      <Badge variation="info" width="fit-content" margin="3px">
                        <Text>{o}</Text>
                        {
                          <Icon marginLeft="5px" as={MdCancel} onClick={() => 
                            props.onChange({ target: { name: field.name, value: value?.filter(v => v !== o) } })}
                          ></Icon>
                        }
                      </Badge>
                    )
                  }
                </View>}
              <Autocomplete
                label={""}
                size="small"
                placeholder={"Cerca..."}
                options={optionsList[innerField ?? field.name]?.filter(o => !value?.includes(o)).map(v => { return {id: v, label: v}})}
                onSelect={(v) => props.onChange({ target: { name: field.name, value: [...(value ?? []), v.id] } })}
                menuSlots={{
                  Empty: (<View><i>Nessun risultato</i></View>)
                }}
              />
            </View>
          );
      case "UploadField":
        return (
        <View columnSpan={field.columnSpan} key={field.name} className={field.name.replaceAll('.', '-')}>
          <View marginBottom="10px"><b>{field.label}{field.isRequiredScheda&&<Text as="span" fontSize="0.8rem" color="red">{' *'}</Text>}</b>{JSON.stringify(value) !== JSON.stringify(savedValue) && <i> (modificato)</i>}</View>
          {(value == null) ? 
            <DropZone
            isDisabled={isUploading[(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]}
            acceptedFileTypes={field.acceptedFileTypes}
            onDropComplete={({ acceptedFiles, rejectedFiles }) => {
              uploadFile(field, acceptedFiles[0], index, outerField);
            }}
          >
            <Flex direction="column" alignItems="center">
              {
                !showWebcam[(outerField ? (outerField + '.') : '') + (index !== undefined ? (index + '.') : '') + field.name] && 
                <>
                  <Text>Trascina il file qui o</Text>
                  <Button
                    size="small"
                      isDisabled={isUploading[(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]}
                      onClick={() => {
                        const input = document.createElement('input');
                        input.type = 'file';
                        input.multiple = true;
                        input.accept = field.acceptedFileTypes.join(',');
                        input.style.display = 'none';
                          input.onchange = (event) => !(!(event.target as any).files || (event.target as any).files.length === 0) && uploadFile(field, (event.target as any).files[0], index, outerField);
                        document.body.appendChild(input);
                        input.click();
                        document.body.removeChild(input);
                      }}
                  >
                    Carica file
                  </Button>
                  {
                    field.dataType === 'image' && 
                    <Button
                      size="small"
                      isDisabled={isUploading[(outerField ? (outerField + '.') : '') + (index !== undefined ? (index + '.') : '') + field.name]}
                      onClick={() => setShowWebcam({...showWebcam, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: true})}
                    >
                      Usa webcam
                    </Button> 
                  }
                </>
              }
              {
                showWebcam[(outerField ? (outerField + '.') : '') + (index !== undefined ? (index + '.') : '') + field.name] && <div>
                  <Webcam
                    audio={false}
                    screenshotFormat="image/jpeg"
                    width={"100%"}
                    ref={webcamRef}
                  />
                  <br/>
                  <Button variation="primary" onClick={() => {
                    const imageSrc = webcamRef.current.getScreenshot();
                    fetch(imageSrc)
                      .then(res => res.blob())
                      .then(blob => {
                        const file = new File([blob], "photo.jpg", { type: "image/jpeg" });
                        uploadFile(field, file, index, outerField);
                      });
                    setShowWebcam({...showWebcam, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: false})
                  }}>Scatta foto</Button>
                  <Button marginLeft="15px" onClick={() => {
                    setShowWebcam({...showWebcam, [(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name]: false})
                  }}>Annulla</Button>
                </div>
              }
              {isUploading[(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name] && <Loader></Loader>}
              {isErrorUpload[(outerField ? (outerField + '.') : '') + (index !== undefined ? (index + '.') : '') + field.name] && <Text color="red">Errore nel caricamento del file!</Text>}
            </Flex>
          </DropZone> : 
            <Flex>
              <Text>
                {
                  field.dataType === "image" ?
                  <Link onClick={() => window.open(imagesUrl[field.name], '_blank')}>
                    {
                      imagesUrl[field.name] ? 
                      <Image src={imagesUrl[field.name] ?? ''} alt={field.name ?? ''} maxWidth="300px" maxHeight="300px"/> :
                      <Loader></Loader>
                    }
                  </Link> :                
                  <Link onClick={async () => {window.open(await getFileUrl(value), "_blank")}}>{value}</Link>
                }
                <Icon 
                  as={MdCancel} 
                  color="red" 
                  marginLeft="5px" 
                  marginBottom="2px" 
                  style={{cursor: "pointer", float: "right"}}
                  onClick={() => props.onChange({target: {name: field.name, value: null}})}
                  >
                </Icon>
              </Text>
            </Flex>
        }
        </View>
        );
      case "SelectField":
        return (
          <View columnSpan={field.columnSpan} key={field.name} className={field.name.replaceAll('.', '-')}>
            <SelectField
              value={value}
              placeholder={"-"}
              options={optionsList[innerField ?? field.name]}
              onChange={props.onChange}
              onBlur={props.onBlur}
              name={field.name}
              disabled={field.disabled}
              label={<Text><b>{field.label}{field.isRequiredScheda&&<Text as="span" fontSize="0.8rem" color="red">{' *'}</Text>}</b>{value !== savedValue && <i> (modificato)</i>}</Text>}
              isRequired={field.isRequired}
            />
          </View>
        );
      case "CheckboxField":
        return (
          <View columnSpan={field.columnSpan} key={field.name} className={field.name.replaceAll('.', '-')}>
            <View marginBottom="10px"><b>{field.label}{field.isRequiredScheda&&<Text as="span" fontSize="0.8rem" color="red">{' *'}</Text>}</b>{JSON.stringify(value) !== JSON.stringify(savedValue) && <i> (modificato)</i>}</View>
            <Grid 
              templateColumns={{ base: '1fr', large: '1fr 1fr 1fr 1fr' }}
              gap='5px'
              >
              {optionsList[innerField ?? field.name]?.map(option => (
                <CheckboxField
                  key={option}
                  value={option}
                  name={option}
                  label={option}
                  checked={value?.includes(option)}
                  onBlur={props.onBlur}
                  onChange={(e) => {
                    const valueArray = value || [];
                    if (e.target.checked) {
                      props.onChange({ target: { name: field.name, value: [...valueArray, option] } });
                    } else {
                      props.onChange({ target: { name: field.name, value: valueArray.filter(v => v !== option) } });
                    }
                  }}
                />
              ))}
            </Grid>
          </View>
        );
      case "TextAreaField":
        return (
          <View columnSpan={field.columnSpan} key={field.name} className={field.name.replaceAll('.', '-')}>
            <TextAreaField
              value={value}
              onChange={props.onChange}
              onBlur={props.onBlur}
              name={field.name}
              label={<Text><b>{field.label}{field.isRequiredScheda&&<Text as="span" fontSize="0.8rem" color="red">{' *'}</Text>}</b>{value !== savedValue && <i> (modificato)</i>}</Text>}
              isRequired={field.isRequired}
            />
          </View>
        );
      case "CheckboxDateField":
          return (
            <View columnSpan={field.columnSpan} key={field.name} className={field.name.replaceAll('.', '-')}>
              <View marginBottom="10px"><b>{field.label}{field.isRequiredScheda&&<Text as="span" fontSize="0.8rem" color="red">{' *'}</Text>}</b>{JSON.stringify(value) !== JSON.stringify(savedValue) && <i> (modificato)</i>}</View>
              <View style={{'display': 'grid', 'gridTemplateColumns': 'repeat(3, 1fr)', 'gap': '5px'}}>
                {optionsList[innerField ?? field.name]?.map((option, index) => (
                  <View key={option}>
                    <CheckboxField
                      value={option}
                      name={option}
                      label={option}
                      checked={value?.find(v => v.id === option) !== undefined}
                      onBlur={props.onBlur}
                      onChange={(e) => {
                        const valueArray = value || [];
                        if (e.target.checked) {
                          props.onChange({ target: { name: field.name, value: [...valueArray, {id: option, ora_inizio: '', ora_fine: ''}] } });
                        } else {
                          props.onChange({ target: { name: field.name, value: valueArray.filter(v => v.id !== option) } });
                        }
                      }}
                    />
                      <Flex marginBottom="10px">
                      <TextField
                        disabled={value?.find(v => v.id === option) === undefined}
                        size="small"
                        key={option+"ora_inizio"}
                        value={value?.find(v => v.id === option)?.ora_inizio}
                        onBlur={props.onBlur}
                        onChange={(e) => {
                          const valueArray = value || [];
                          props.onChange({ 
                            target: { name: field.name, value: valueArray.map(v => {
                              return v.id === option ? {...v, ora_inizio: e.target.value} : v
                            })}
                          })
                        }}
                        name={"ora_inizio"}
                        type="time"
                        label={"dalle"}
                      />
                      <TextField
                        disabled={value?.find(v => v.id === option) === undefined}
                        size="small"
                        key={option+"ora_fine"}
                        value={value?.find(v => v.id === option)?.ora_fine}
                        onBlur={props.onBlur}
                        onChange={(e) => {
                          const valueArray = value || [];
                          props.onChange({ 
                            target: { name: field.name, value: valueArray.map(v => {
                              return v.id === option ? {...v, ora_fine: e.target.value} : v
                            })}
                          })
                        }}
                        name={"ora_fine"}
                        type="time"
                        label={"alle"}
                      />
                      </Flex> 
                  </View>
                ))}
              </View>
            </View>)
      default:
        return null;
    }
  };

  return (
    <>
    <Grid 
      templateColumns={{ base: '1fr', large: '1fr 1fr 1fr 1fr' }}
      gap="20px">
      {formConfig.sections.map((section, sectionIndex) => (
        <React.Fragment key={section.title}>
          <View columnSpan={[1, 1, 1, 4]}><h4>{section.title}</h4></View>
          {section.showCopyButton && 
          <View columnSpan={[1, 1, 1, 4]}>
            <Button size="small" onClick={() => section.copyFunction(props)}>
              <Icon as={MdDynamicForm} marginRight="5px"/>{section.copyLabel ?? 'Copia'}</Button>
          </View>}
          {section.fields.filter(f => f.isVisible !== undefined ? f.isVisible(props.value) : true).map(o => renderField(o, false))}
          <View columnSpan={[1, 1, 1, 4]}></View>
        </React.Fragment>
      ))}
    </Grid>
    </>
  );
};

export default ClienteForm;
